/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.FontCabecera[_ngcontent-%COMP%]{font-weight:700}.fila-pago[_ngcontent-%COMP%]{font-family:Arial,sans-serif;font-size:14px;font-weight:700;color:#00f;margin-top:5px;margin-bottom:5px}"];
export { styles as styles };
